import axiosInstance from './axios-instance';

export const trendingTopicsApi = {
  // Get published trending topics for main UI
  getPublishedTrendingTopics: async (category = null, limit = 10, search = null) => {
    try {
      const params = new URLSearchParams();
      if (category && category !== 'All') {
        // Map frontend category names to backend enum values
        const categoryMap = {
          Technology: 'TECHNOLOGY',
          Politics: 'POLITICS',
          Health: 'HEALTH',
          Environment: 'ENVIRONMENT',
          Business: 'BUSINESS',
          Science: 'SCIENCE',
          Sports: 'SPORTS'
        };
        params.append('category', categoryMap[category] || category.toUpperCase());
      }
      if (search && search.trim()) {
        params.append('search', search.trim());
      }
      params.append('limit', limit.toString());

      const url = `/api/v1/publisher/api/internal/trending-topics/published${params.toString() ? `?${params.toString()}` : ''}`;

      const response = await axiosInstance.get(url);
      return {
        success: true,
        data: response.data || []
      };
    } catch (error) {
      console.error('Error fetching published trending topics:', error);
      return {
        success: false,
        error: error?.response?.data?.message || 'Failed to fetch trending topics',
        data: []
      };
    }
  },

  // Get a single trending topic by ID
  getTrendingTopicById: async (id) => {
    try {
      const response = await axiosInstance.get(
        `/api/v1/publisher/api/internal/trending-topics/${id}`
      );
      return {
        success: true,
        data: response.data || null
      };
    } catch (error) {
      console.error('Error fetching trending topic by ID:', error);
      return {
        success: false,
        error: error?.response?.data?.message || 'Failed to fetch trending topic',
        data: null
      };
    }
  }
};
